'use strict';

angular.module('esn.calendar.libs')
  .constant('CAL_FREEBUSY', {
    UNKNOWN: 'unknown',
    FREE: 'free',
    BUSY: 'busy',
    LOADING: 'loading'
  });
